import { defineComponent as _defineComponent } from 'vue'
import AdminReportsByEOIs from "@/components/reports/AdminReportsByEOIs.vue";
  import AdminReportsByLeads from "@/components/reports/AdminReportsByLeads.vue";
  import SiteVisitorsFromAnalytics from "@/components/reports/SiteVisitorsFromAnalytics.vue";
  import ConversionFromAnalytics from "@/components/reports/ConversionFromAnalytics.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useRouter } from "vue-router";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import { ref, onMounted } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EstateGraphs',
  setup(__props, { expose: __expose }) {
  __expose();

  const router = useRouter();
  const store = useStore();
  const toast = useToast();

  const stateId = router.currentRoute.value.params.stateId;
  const estate = ref<EstateInterface>();
  const loading = ref(false);

  const timePeriodSelected = ref<ReportsTimePeriod>(
    ReportsTimePeriod.LAST_MONTH
  );
  const optionsTimePeriod = [
    ReportsTimePeriod.LAST_MONTH,
    ReportsTimePeriod.LAST_WEEK,
  ];

  const selectTimePeriod = (reportsTimePeriod: ReportsTimePeriod) => {
    timePeriodSelected.value = reportsTimePeriod;
  };
  const getEstate = async () => {
    loading.value = true;
    store
      .dispatch("estate/getEstate", stateId)
      .then((res) => {
        estate.value = res.data;
        loading.value = false;
      })
      .catch((error) => {
        toast.error("Error getting estates");
      });
  };

  onMounted(() => {
    getEstate();
  });

const __returned__ = { router, store, toast, stateId, estate, loading, timePeriodSelected, optionsTimePeriod, selectTimePeriod, getEstate, AdminReportsByEOIs, AdminReportsByLeads, SiteVisitorsFromAnalytics, ConversionFromAnalytics, DropDown, get ReportsTimePeriod() { return ReportsTimePeriod }, get EstateInterface() { return EstateInterface }, get useRouter() { return useRouter }, get useStore() { return useStore }, get useToast() { return useToast }, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})